import { Link } from "react-router-dom";
import Reveal from "../components/Reveal";
import SectionLabel from "../components/SectionLabel";
import useDocumentTitle from "../hooks/useDocumentTitle";
import { IMAGES } from "../data/content";

export default function Individualisierung() {
  useDocumentTitle(
    "Individualisierung — Vor-Ort-Planung & Konfigurator",
    "Standard, wo sinnvoll. Individuell, wo nötig. Persönliche Vor-Ort-Planung oder geführter Konfigurator für Ihr Ferienobjekt."
  );

  return (
    <div data-testid="page-individualisierung">
      {/* Hero */}
      <section className="pt-28 sm:pt-32 md:pt-44 pb-16 md:pb-24">
        <div className="container-livinora">
          <Reveal>
            <SectionLabel index="∞" text="Individualisierung" />
          </Reveal>
          <Reveal delay={60}>
            <h1 className="display-xl mt-8 text-[44px] sm:text-[60px] md:text-[80px] lg:text-[96px] text-balance max-w-5xl">
              Standard, wo sinnvoll.
              <br className="hidden sm:block" />
              Individuell, wo nötig.
            </h1>
          </Reveal>
          <Reveal delay={140}>
            <p className="prose-livinora prose-livinora--lead mt-9 max-w-2xl">
              Livinora arbeitet innerhalb klarer Konzepte. Innerhalb dieses Rahmens passen wir Ihr
              Projekt präzise an — digital geführt oder persönlich begleitet.
            </p>
          </Reveal>
        </div>
      </section>

      {/* Two paths */}
      <section className="pb-20 md:pb-28">
        <div className="container-livinora grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
          {/* Path A — On-site */}
          <Reveal>
            <article className="card-depth overflow-hidden flex flex-col h-full">
              <div className="media-wrap aspect-[5/3]">
                <img
                  src={IMAGES.individualization}
                  alt="Vor-Ort-Planung"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="p-8 sm:p-10 md:p-12 flex-1 flex flex-col">
                <span className="micro-label">Pfad A · Persönlich</span>
                <h2 className="display-xl mt-5 text-[32px] sm:text-[40px] md:text-[44px] leading-[1.04]">
                  Vor-Ort-Planung
                </h2>
                <p className="prose-livinora mt-7">
                  Unser Planungsteam — inklusive Interior Architect — kommt zu Ihnen. Wir nehmen
                  Maß, analysieren das Objekt und übersetzen Ihre Ziele in ein belastbares,
                  individuelles Konzept.
                </p>
                <ul className="mt-8 space-y-2 text-sm">
                  <li className="flex items-start gap-3"><span className="mt-[9px] w-3 h-px bg-[color:var(--livinora-ink)]" /> Aufmaß & Bestandsaufnahme</li>
                  <li className="flex items-start gap-3"><span className="mt-[9px] w-3 h-px bg-[color:var(--livinora-ink)]" /> Anpassung von Maßen, Zuschnitten, Akzenten</li>
                  <li className="flex items-start gap-3"><span className="mt-[9px] w-3 h-px bg-[color:var(--livinora-ink)]" /> Koordination mit Handwerk & Logistik</li>
                  <li className="flex items-start gap-3"><span className="mt-[9px] w-3 h-px bg-[color:var(--livinora-ink)]" /> Persönliche Beratung im Prozess</li>
                </ul>
                <Link
                  to="/kontakt"
                  className="btn-livinora btn-primary btn-magnetic mt-10 self-start"
                  data-testid="indiv-vor-ort-cta"
                >
                  Vor-Ort-Planung anfragen <span>→</span>
                </Link>
              </div>
            </article>
          </Reveal>

          {/* Path B — Configurator */}
          <Reveal delay={120}>
            <article className="card-depth card-depth--warm overflow-hidden flex flex-col h-full">
              <div className="media-wrap aspect-[5/3]">
                <img
                  src={IMAGES.intro}
                  alt="Konfigurator"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="p-8 sm:p-10 md:p-12 flex-1 flex flex-col">
                <span className="micro-label">Pfad B · Digital</span>
                <h2 className="display-xl mt-5 text-[32px] sm:text-[40px] md:text-[44px] leading-[1.04]">
                  Konfigurator
                </h2>
                <p className="prose-livinora mt-7">
                  Ein geführter digitaler Prozess — elegant, schnell, ohne Überforderung. Ideal,
                  um Ihr Objekt selbstständig durchzudenken, Varianten zu vergleichen und einen
                  sinnvollen Ausgangspunkt für Ihre Anfrage zu schaffen.
                </p>
                <ul className="mt-8 space-y-2 text-sm">
                  <li className="flex items-start gap-3"><span className="mt-[9px] w-3 h-px bg-[color:var(--livinora-ink)]" /> Objekttyp & Größe</li>
                  <li className="flex items-start gap-3"><span className="mt-[9px] w-3 h-px bg-[color:var(--livinora-ink)]" /> Stilserie & Paket</li>
                  <li className="flex items-start gap-3"><span className="mt-[9px] w-3 h-px bg-[color:var(--livinora-ink)]" /> Zusatzmodule & Add-ons</li>
                  <li className="flex items-start gap-3"><span className="mt-[9px] w-3 h-px bg-[color:var(--livinora-ink)]" /> Direkt zur Projektanfrage</li>
                </ul>
                <Link
                  to="/konfigurator"
                  className="btn-livinora btn-ghost mt-10 self-start"
                  data-testid="indiv-konfig-cta"
                >
                  Konfigurator starten
                </Link>
              </div>
            </article>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
